<template>
  <div class="flex items-center">
    <aha-antd-button
      class="hidden-report md-flex"
      name="session-dropdown-button"
      v-aha-emit-action
      variant="secondary"
      @click="openModalSessions()"
    >
      <span v-if="selectedSession">Session {{ selectedSession.index }}</span>
      <aha-icon
        name="arrow"
        class="down-arrow ml-1"
        width="12"
        height="12"
        viewBox="0 0 24 24"
      />
    </aha-antd-button>
    <div class="flex items-center ml-3" v-if="snapshotInfo.instructor">
      <aha-avatar
        :id="snapshotInfo.instructor.id"
        :name="`${snapshotInfo.instructor.firstName} ${snapshotInfo.instructor.lastName}`"
        :image="snapshotInfo.instructor.avatar"
        :width="24"
        :height="24"
        class="text-xs mr-1"
      />
      {{ snapshotInfo.instructor.firstName }} {{ snapshotInfo.instructor.lastName }}
    </div>
    <ReportSessionsModal
      v-if="isShowModalSessions"
      :sessions="sessions"
      @hide="hideModalSessions"
    />
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import ReportSessionsModal from '@/components-v2/presentation-report/ReportSessionsModal'
import ahaSystem from '@/constant/ahaSystem'

export default {
  components: {
    ReportSessionsModal,
  },
  props: {
    snapshotInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      sessions: [],
      isShowModalSessions: false,
      ahaSystem,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
    }),
    ...mapGetters('multipleSessions', ['canUseMultipleSessions', 'selectedSession']),
  },
  mounted() {
    this.getMasterPresentation()
  },
  methods: {
    ...mapActions('multipleSessions', ['getPresentationMasterByPresentationIdAction', 'getListSessionsByPresentationIdAction', 'setDefaultSelectedSession']),
    ...mapActions('featureToggles', ['updateFeatureContext']),
    async getMasterPresentation() {
      try {
        if (this.canUseMultipleSessions) {
          let masterPresentationId = this.$route.params.id
          const resp = await this.getPresentationMasterByPresentationIdAction(masterPresentationId)
          if (resp) {
            masterPresentationId = resp.rootPresentation.id
          }
          const respListSession = await this.getListSessionsByPresentationIdAction(masterPresentationId)

          if (resp) {
            respListSession.sessions.unshift({
              presentationId: masterPresentationId,
              createdAt: resp.rootPresentation.updatedAt,
              updatedAt: resp.rootPresentation.updatedAt,
              isRoot: true,
              instructor: masterPresentationId == this.presentation.id ? this.currentUser : resp.rootPresentation.User,
            })
          } else {
            respListSession.sessions.unshift({
              presentationId: masterPresentationId,
              createdAt: this.presentation.updatedAt,
              updatedAt: this.presentation.updatedAt,
              isRoot: true,
              instructor: this.presentation.User,
            })
          }
          respListSession.sessions.forEach((item, key) => {
            item.index = respListSession.sessions.length - key
          })
          this.sessions = respListSession.sessions

          if (!this.selectedSession) {
            const index = this.sessions.findIndex(
              (session) => {
                return parseInt(session.presentationId, 10) === parseInt(this.$route.params.id, 10) && !session.isRoot
              },
            )
            if (index !== -1) {
              this.setDefaultSelectedSession(this.sessions[index])
            } else {
              this.setDefaultSelectedSession(this.sessions[0])
            }
          }
        }
      } catch (error) {
        // do thing
        Sentry.captureException(new Error('Load list sessions error'), {
          extra: {
            error,
          },
        })
      }
    },
    openModalSessions() {
      this.isShowModalSessions = true
    },
    hideModalSessions() {
      this.isShowModalSessions = false
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
